import { render } from "./NutriprozTestTabPane.vue?vue&type=template&id=523707e4&scoped=true"
import script from "./NutriprozTestTabPane.vue?vue&type=script&lang=js"
export * from "./NutriprozTestTabPane.vue?vue&type=script&lang=js"

import "./NutriprozTestTabPane.vue?vue&type=style&index=0&id=523707e4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523707e4"]])

export default __exports__